import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Divider, Type } from "discover.medical.react-component-library";
import debounce from "lodash/debounce";

import {
  DrugInteractionsPolicyWrapper,
  DrugInteractionsPolicyTitle,
  DrugInteractionsPolicyAcceptButton,
  DrugInteractionsPolicyHeader,
} from "./styled";
import { acceptPolicy } from "../../../store/drug-interactions/actions";
import { useDispatch } from "../../../store/";
import { shouldEnablePolicyBtn } from "./util/utils";

const DrugInteractionsPolicy = ({ viewModel }) => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const [buttonIsEnabled, setButtonIsEnabled] = useState(false);
  const { title: headerText } = viewModel.header;
  const { title, description, termsText, accept } = viewModel.termsContent;

  useEffect(() => {
    const updateBtnAvailability = () => {
      const isBtnEnabled = shouldEnablePolicyBtn(containerRef.current);
      setButtonIsEnabled(isBtnEnabled);
    };

    const handleWindowEvent = debounce(updateBtnAvailability, 250);

    updateBtnAvailability();

    window.addEventListener("scroll", handleWindowEvent);
    window.addEventListener("resize", handleWindowEvent);

    return () => {
      window.removeEventListener("scroll", handleWindowEvent);
      window.removeEventListener("resize", handleWindowEvent);
    };
  }, []);

  const handleAcceptPolicy = () => {
    acceptPolicy(dispatch, accept.functionArgs.apiPath);
  };

  return (
    <>
      <DrugInteractionsPolicyHeader align={{ items: "stretch" }} column>
        <Type element="h1" color="gray800" fontFamily="secondary">
          {headerText}
        </Type>
      </DrugInteractionsPolicyHeader>
      <DrugInteractionsPolicyWrapper
        ref={containerRef}
        width="100%"
        marginTop="sm"
        data-testid="drug-interactions-root"
      >
        <DrugInteractionsPolicyTitle
          element="h2"
          paddingBottom="sm"
          color="primary"
        >
          {title}
        </DrugInteractionsPolicyTitle>
        <Type element="p" paddingBottom="sm">
          {description}
        </Type>

        <Divider horizontal />

        <Type element="p">{termsText}</Type>

        <DrugInteractionsPolicyAcceptButton
          children={accept.label}
          disabled={!buttonIsEnabled}
          onClick={handleAcceptPolicy}
          data-testid="accept-policy"
        />
      </DrugInteractionsPolicyWrapper>
    </>
  );
};

DrugInteractionsPolicy.displayName = "DrugInteractionPolicy";

DrugInteractionsPolicy.propTypes = {
  viewModel: PropTypes.shape({
    header: PropTypes.shape({
      label: PropTypes.string,
    }),
    termsContent: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      termsText: PropTypes.string,
      accept: PropTypes.shape({
        type: PropTypes.string,
        label: PropTypes.string,
        route: PropTypes.string,
        routeData: PropTypes.object,
        hash: PropTypes.string,
        function: PropTypes.string,
        functionArgs: PropTypes.shape({
          apiPath: PropTypes.string,
          telemetryData: PropTypes.object,
        }),
      }),
    }),
  }),
};

export default DrugInteractionsPolicy;
